export default "__VITE_ASSET__BQS5L8lS__"